import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FaBars, FaTimes } from 'react-icons/fa'

const MenuItem = ({ to, label, onClick, isActive, isHome, sectionId }) => {


  const handleClick = (e) => {
    // If we are on Home page and target is a section
    if (isHome && sectionId) {
      e.preventDefault();
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        onClick && onClick(); // Close menu
      }
    } else {
      // Normal navigation
      onClick && onClick();
    }
  };

  const linkTarget = isHome && sectionId ? `/#${sectionId}` : to;

  return (
    <a
      href={linkTarget}
      onClick={handleClick}
      className={`m-2 font-bold font-serif px-1 py-2 no-underline cursor-none transition-colors duration-300 relative group
        ${isActive ? 'text-purple-400' : 'text-white hover:text-purple-400'}`}
    >
      {label}
      <span className={`absolute left-0 bottom-0 h-0.5 bg-gradient-to-r from-purple-400 to-pink-600 transition-all duration-300 
        ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`}></span>
    </a>
  );
};

const Navbar = ({ isHome = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  }

  // Check if path matches or if hash matches (roughly)
  const isActive = (path) => location.pathname === path;

  return (
    <div className='absolute z-50 w-full top-0 left-0 bg-gradient-to-b from-black/80 to-transparent'>
      <div className='md:flex items-center justify-between text-white py-4 md:px-10 px-7'>
        <Link to="/">
          <img
            src="https://res.cloudinary.com/dbszbhg8n/image/upload/v1680347659/Screenshot_2023-04-01_163808_rqjrag.png"
            alt="logo"
            className="w-16 h-18 shadow-lg transform transition-transform duration-300 hover:scale-125 md:ml-0 ml-0 rounded-full bg-white/10 backdrop-blur-sm"
          />
        </Link>

        {/* Mobile Menu Button - Added visible colors and background for visibility */}
        <div onClick={toggleMenu} className='text-3xl absolute right-8 top-6 cursor-none md:hidden text-white hover:text-purple-400 transition-colors z-[60] bg-black/20 p-2 rounded-lg backdrop-blur-sm'>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={`md:flex md:items-center md:pb-0 pb-12 absolute md:static bg-black/95 md:bg-white/5 md:backdrop-blur-sm md:rounded-full md:px-8 md:py-2 md:z-auto z-40 left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${isOpen ? 'top-0 pt-24 opacity-100 h-screen' : 'top-[-490px] md:top-auto md:h-auto'}`}>
          {/* Home Link - Always goes to top */}
          <li className='md:ml-8 text-xl md:my-0 my-7'>
            <MenuItem
              to="/"
              label="Home"
              sectionId="home"
              isHome={isHome}
              onClick={() => setIsOpen(false)}
              isActive={isActive('/') || isActive('/home')}
            />
          </li>

          <li className='md:ml-8 text-xl md:my-0 my-7'>
            <MenuItem
              to="/about"
              label="About"
              sectionId="about"
              isHome={isHome}
              onClick={() => setIsOpen(false)}
              isActive={isActive('/about')}
            />
          </li>

          <li className='md:ml-8 text-xl md:my-0 my-7'>
            <MenuItem
              to="/projects"
              label="Projects"
              sectionId="projects"
              isHome={isHome}
              onClick={() => setIsOpen(false)}
              isActive={isActive('/projects')}
            />
          </li>

          <li className='md:ml-8 text-xl md:my-0 my-7'>
            <MenuItem
              to="/skills"
              label="Skills"
              sectionId="skills"
              isHome={isHome}
              onClick={() => setIsOpen(false)}
              isActive={isActive('/skills')}
            />
          </li>

          <li className='md:ml-8 text-xl md:my-0 my-7'>
            <MenuItem
              to="/experience"
              label="Experience"
              sectionId="experience"
              isHome={isHome}
              onClick={() => setIsOpen(false)}
              isActive={isActive('/experience')}
            />
          </li>

          <li className='md:ml-8 text-xl md:my-0 my-7'>
            <MenuItem
              to="/contact"
              label="Contact"
              sectionId="contact"
              isHome={isHome}
              onClick={() => setIsOpen(false)}
              isActive={isActive('/contact')}
            />
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Navbar
